<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    @click:outside="cancel"
  >
    <v-card>
      <v-container
        fluid
        :class="{
          'px-10': !mobile,
          'pt-8': !mobile,
          'px-4': mobile
        }"
      >
        <p class="subtitle-1 font-weight-bold">{{ title }}</p>
        <v-card-text v-show="!!message" class="px-0">
          <p class="body-1">{{ message }}</p>
        </v-card-text>
        <v-textarea
          v-model="description"
          label="(Optional) Update description"
          hide-details
          dense
          outlined
          class="my-1"
          rows="3"
        >
        </v-textarea>
        <v-file-input
          v-model="attachments"
          accept="image/*, application/pdf"
          label="Upload Attachments"
          prepend-icon=""
          chips
          small-chips
          multiple
          outlined
          dense
          hide-details
        >
          <template v-slot:prepend-inner>
            <v-icon small class="mt-1">mdi-paperclip</v-icon>
          </template>
        </v-file-input>
        <p
          v-if="currentAttachments.length"
          class="caption font-weight-bold mt-2"
        >
          Attachments
        </p>
        <v-chip-group column multiple>
          <v-chip
            v-for="(item, index) in currentAttachments"
            :key="index"
            close
            @click:close="removeAttachment(item, index)"
          >
            {{ truncate(item.filename) }}
          </v-chip>
        </v-chip-group>
        <v-card-actions :class="{ 'pt-4': !mobile, 'pt-1': mobile }">
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            @click.native="agree"
            >Update</v-btn
          >
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click.native="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    denyText: null,
    cancelText: null,
    defaultOptions: {
      color: 'primary',
      width: 400,
      zIndex: 200
    },
    options: {
      color: 'primary',
      width: 400,
      zIndex: 200
    },
    showDeny: false,
    description: null,
    attachments: [],
    currentAttachments: []
  }),
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    open(params) {
      const { title, message, options, description, currentAttachments } =
        params
      this.dialog = true
      this.title = title
      this.message = message
      this.description = description
      this.currentAttachments = currentAttachments || []
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.options = this.defaultOptions
      this.resolve({
        success: true,
        description: this.description,
        attachments: this.attachments,
        currentAttachments: this.currentAttachments
      })
      this.dialog = false
    },
    cancel() {
      this.options = this.defaultOptions
      this.resolve(false)
      this.dialog = false
    },
    async removeAttachment(item, index) {
      if (
        await this.$root.$confirm({
          title: 'Remove attachment',
          message: `Are you sure you would like to delete ${item.filename}?`
        })
      ) {
        this.currentAttachments.splice(index, 1)
      }
    },
    truncate(input) {
      if (input && input.length > 7) {
        return input.substring(0, 7) + '...'
      }
      return input
    }
  }
}
</script>

<style scoped>
.v-dialog {
  border-radius: 12px !important;
}
.body-1 {
  white-space: pre-wrap;
}
</style>
